import { jsx as r, jsxs as i } from "react/jsx-runtime";
import { useState as u, useRef as d, useEffect as f } from "react";
import { getImageLoading as p } from "../../../../helpers/image-helper.js";
import l from "./top-image.module.less.js";
import o from "../../../../animation/animation.module.less.js";
const j = ({ imageDesktop: e, imageMobile: t, blockIndex: c }) => {
  const [m, s] = u(!1), a = d(null);
  return f(() => {
    if (a.current?.complete)
      s(!0);
    else {
      const n = setInterval(() => {
        a.current?.complete && (s(!0), clearInterval(n));
      }, 250);
    }
    return () => {
    };
  }, []), /* @__PURE__ */ r("div", { className: l.wrapper, children: (e?.url || t?.url) && /* @__PURE__ */ i("picture", { children: [
    /* @__PURE__ */ r("source", { srcSet: t?.url, media: "(max-width: 767px)" }),
    /* @__PURE__ */ r("source", { srcSet: e?.url, media: "(min-width: 768px)" }),
    /* @__PURE__ */ r(
      "img",
      {
        ref: a,
        src: e?.url,
        className: [l.image, m ? o.fadeIn : o.opacity0].join(" "),
        alt: t?.alt || e?.alt,
        loading: p(c ?? 0)
      }
    )
  ] }) });
};
export {
  j as TopImage
};
